const CONNECTION_SEPARATION_MS = 3000;

export class ConnectionRateLimiter {
    private nextAllowedConnection: number;

    constructor () {
        this.nextAllowedConnection = 0;
    }

    getWsConnection = (retriever: () => Promise<string>) => {
        return new Promise<string>((resolve, reject) => {
            const now = Date.now();
            const delay = this.nextAllowedConnection - now;
            if (delay <= 0) {
                resolve(retriever());
                this.nextAllowedConnection = now + CONNECTION_SEPARATION_MS;
            } else {
                // too many requests can cause the delay to be excessive
                if (delay > 3 * CONNECTION_SEPARATION_MS) {
                    reject(new Error('Too many requests'));
                    return;
                }

                setTimeout(() => {
                    resolve(retriever());
                }, delay);
                this.nextAllowedConnection = now + delay + CONNECTION_SEPARATION_MS;
            }
        });
    };
}
